import React, {Component} from 'react'
import {
    Link
} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'
import Image from '../../common/image/image.component.jsx'
import GlobalHelper from "../../common/GlobalHelper.jsx";
import Icon from "../../common/icon/icon.component.jsx"
import AddressComponent from "../../customer/components/AddressComponent";

class CompanyDetailsSection extends Component {

    renderAddress() {
        let companyName = ""
        if (this.props.companyName !== undefined) {
            companyName = this.props.companyName
        }
        let companyPhoneNumber = ""
        if (this.props.companyPhoneNumber !== undefined) {
            companyPhoneNumber = this.props.companyPhoneNumber
        }
        let companyEmail = ""
        if (this.props.companyEmail !== undefined) {
            companyEmail = this.props.companyEmail
        }
        return (
            <ul className="list-unstyled">
                <li>{companyName}</li>
                <li>{GlobalHelper.formatPhoneNumber(companyPhoneNumber, this.props.companyCountryCode)}</li>
                <li>{companyEmail}</li>
            </ul>
        );
    }


    render() {

        let address = this.renderAddress()
        let companyLogo = ''
        if (this.props.companyLogoImageId !== undefined && this.props.companyLogoImageId !== "") {
            companyLogo = <Image imageId={this.props.companyLogoImageId} size="small"/>
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.companyDetails'
                                        description='Title to identify the section where the user can visualize the company description'
                                        defaultMessage='My company details'
                                    />
                                </h2>
                            </div>
                            <div className="col-4 justify-content-end action-bar text-right">
                                <Link to="/settings/editCompanyDetails" className="btn btn-primary">
                                    <Icon value={"edit"}/>
                                    <FormattedMessage
                                        id="settings.edit_company_details_btn"
                                        defaultMessage="Edit Company Details"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            {address}
                            {this.props.companyAddress && <AddressComponent value={this.props.companyAddress}/>}
                            <p>
                                {companyLogo}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default CompanyDetailsSection


// WEBPACK FOOTER //
// ./src/settings/companyDetails/companyDetailsSection.component.jsx